<template>
  <div :class="{ 'current': searchTerm.text === st.text }">
    <div>
      <div class='search-term-text'>{{ st.text }}</div>
      <div class='search-term-date small'>
        {{ st.lastGeogridData.createdAt || 'not created yet' }}
      </div>
      <div class='mt-3' v-if='searchTerm.text === st.text'>
        <button
          id='dropdownRunNow'
          data-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'
          type='button'
          class='btn btn-pretender btn-sm pl-0'
          :class="{ 'd-none': !st.lastGeogridData.createdAt }">
          GIF
        </button>
        <button @click='runNow' class='btn btn-pretender btn-sm pl-0'>
          Run now
        </button>
        <div class='dropdown-menu p-0' aria-labelledby='dropdownRunNow'>
          <a
            :href='searchTerm.getAnimationLink'
            target='_blank'
            v-show='searchTerm.geogridsHistoryTimestamp'
            class='dropdown-item small p-x-1'>
            <i class='fa fa-download mr-2' />
            GIF ({{ searchTerm.geogridsHistoryTimestamp }})
          </a>
          <a class='dropdown-item small p-x-1' @click='createGif'>
            <i class='fa fa-film mr-2' />Generate new GIF
          </a>
          <a class='dropdown-item small p-x-1' @click='createGif(false)'>
            <i class='fa fa-film mr-2' />Generate new GIF (no loop)
          </a>
        </div>
      </div>
    </div>
    <div
      class='d-flex justify-content-center small text-md-right align-self-center'
      v-if='st.lastGeogridData.createdAt'>
      <geogridAverageRanks
        :agr='st.lastGeogridData.agr'
        :atgr='st.lastGeogridData.atgr'
        :solv='st.lastGeogridData.solv' />
      <div class='geogrid-preview-wrapper pl-2'>
        <geogridPreview :ranks='st.lastGeogridData.spotsRanks' />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DEFAULT_ERROR_MESSAGE, NOT_ENOUGH_GEOGRID_CREDITS } from '../../../../common/constants'
import geogridPreview from '../../components/geogrid_preview'
import geogridAverageRanks from '../../components/geogrid_average_ranks'

export default {
  name: 'St',
  props: {
    st: Object,
    current: {
      type: Boolean,
      default: false
    }
  },
  computed: mapState(['config', 'searchTerm', 'geogrid']),
  components: { geogridPreview, geogridAverageRanks },
  methods: {
    createGif(loop = false) {
      axios.post(
        this.searchTerm.createAnimationLink,
        { keyword: this.searchTerm.text, loop: loop }
      ).then((response) => {
        if (response.data.error === 'gif in progress') {
          toastr.error(
            `For ${this.config.attrs.businessName}: ${this.st.text}`,
            'GIF generation in progress'
          )
        } else {
          toastr.success(
            `For ${this.config.attrs.businessName}: ${this.st.text}`,
            'GIF generation started',
            { timeOut: 1000 }
          )
        }
      }).catch((_error) => {
        toastr.error(DEFAULT_ERROR_MESSAGE)
      })
    },
    runNow() {
      axios.post(
        this.searchTerm.onDemainGeogridLink,
        { keyword: this.searchTerm.text }
      ).then((response) => {
        if (response.data.started) {
          toastr.success(
            'It will take a few minutes, please check back a bit later',
            'We started preparing your report'
          )
        } else {
          toastr.error(NOT_ENOUGH_GEOGRID_CREDITS, 'Not enough geogrid credits')
        }
      }).catch((_error) => {
        toastr.error(DEFAULT_ERROR_MESSAGE)
      })
    }
  }
}
</script>
